import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrackets2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBrackets2"><Path fillRule="evenodd" clipRule="evenodd" d="M4 3H9V4.5H5.5V19.5H9V21H4V12.75H2V11.25H4V3ZM15 3H20V11.25H22V12.75H20V21H15V19.5H18.5V4.5H15V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBrackets2;
